var cart_id = '';
var store = 'eu';
var texts = {
    qty: 'Qty:',
    apply: 'Apply',
    remove: 'Remove',
    decrease: 'Decrease quantity',
    increase: 'Increase quantity',
};

var cartReturnFocus = null;
var cartBackgroundElements = [];
var cartPreviousOverflow = '';
var cartRestoreWidgets = null;

function setCartInert(element, hidden) {
  // Legacy Salesforce defines an Element-level polyfill even in browsers with native HTMLElement.inert.
  var descriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'inert');
  if (descriptor && descriptor.set) descriptor.set.call(element, hidden);
  else element.inert = hidden;
}

function setCartBackgroundInert(drawer, hidden) {
  if (!hidden) {
    cartBackgroundElements.forEach(function (element) { setCartInert(element, false); });
    cartBackgroundElements = [];
    return;
  }
  var branch = drawer;
  while (branch && branch.parentElement) {
    Array.prototype.forEach.call(branch.parentElement.children, function (element) {
      if (element === branch || element.matches('.cart-drawer-overlay,script,style,link') || element.hasAttribute('inert')) return;
      setCartInert(element, true);
      cartBackgroundElements.push(element);
    });
    branch = branch.parentElement;
    if (branch === document.body) break;
  }
}

function cartFocusableElements(drawer) {
  return Array.prototype.filter.call(drawer.querySelectorAll('a[href],button,input,select,textarea,[tabindex]'), function (element) {
    return element.tabIndex >= 0 && !element.disabled && element.getClientRects().length &&
      getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]');
  });
}

function focusCartDrawer(drawer) {
  var target = drawer.querySelector('.cart-header .close-btn') || drawer;
  target.focus({ preventScroll: true });
}

document.addEventListener('keydown', function (event) {
  var drawer = document.querySelector('.cart-drawer.show');
  if (!drawer) return;
  if (event.key === 'Escape' || event.keyCode === 27) {
    event.preventDefault();
    event.stopPropagation();
    closeCartDrawer();
  } else if (event.key === 'Tab' || event.keyCode === 9) {
    var elements = cartFocusableElements(drawer);
    var first = elements[0] || drawer;
    var last = elements[elements.length - 1] || drawer;
    if (!drawer.contains(document.activeElement) || !elements.length) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}, true);

document.addEventListener('focusin', function (event) {
  var drawer = document.querySelector('.cart-drawer.show');
  if (drawer && !drawer.contains(event.target)) focusCartDrawer(drawer);
});

$('a.cart-icon, #ccartToggle a').click(function(e) {
  e.preventDefault();
  showCartDrawer(this);
});

$('.cart-drawer-overlay, .cart-drawer .close-btn').click(function(e) {
  e.preventDefault();
  closeCartDrawer();
});

function showCartDrawer(opener) {
  var drawer = document.querySelector('.cart-drawer');
  if (!drawer) return;
  var wasOpen = drawer.classList.contains('show');
  if (!wasOpen) {
    var active = document.activeElement;
    cartReturnFocus = opener || (active && active !== document.body && !drawer.contains(active) ? active : null);
    cartPreviousOverflow = document.body.style.overflow;
    setCartInert(drawer, false);
    drawer.removeAttribute('aria-hidden');
    setCartBackgroundInert(drawer, true);
  }
  $('.cart-drawer-overlay').fadeIn();
  $('.cart-drawer').addClass('show');
  $('body').css('overflow', 'hidden');
  if (!wasOpen) focusCartDrawer(drawer);
  if (!cartRestoreWidgets) cartRestoreWidgets = window.minetanFloatingWidgets.hide();
  if (!wasOpen) fetchCart();
}

function closeCartDrawer() {
  var drawer = document.querySelector('.cart-drawer.show');
  if (!drawer) return;
  $('.cart-drawer-overlay').fadeOut();
  $('.cart-drawer').removeClass('show');
  $('body').css('overflow', cartPreviousOverflow);
  setCartBackgroundInert(drawer, false);
  var target = cartReturnFocus;
  if (!target || !document.documentElement.contains(target) || target.disabled || !target.getClientRects().length) {
    target = $('a.cart-icon, #ccartToggle a').filter(':visible')[0];
  }
  if (target) target.focus({ preventScroll: true });
  drawer.setAttribute('aria-hidden', 'true');
  setCartInert(drawer, true);
  cartReturnFocus = null;
  if (cartRestoreWidgets) cartRestoreWidgets();
  cartRestoreWidgets = null;
  if (window.minetanFullCart) window.minetanFullCart.drawerClosed();
}

var cartChangeQueue = [];
var cartChangeInFlight = null;
var cartChangeRevision = 0;
var cartCurrentState = null;
var cartRefreshPending = false;
var cartReadInFlight = false;
var cartReadRevision = 0;
var cartRefreshRequired = true;
var cartReadFailed = false;
var cartWriteCount = 0;
var cartExternalWrites = 0;
var cartSyncStorageKey = 'minetan-cart-updated';

function cartNeedsReconciliation() {
  return cartRefreshRequired || cartReadInFlight || cartExternalWrites > 0;
}

function requestCartReconciliation() {
  cartChangeRevision++;
  cartRefreshRequired = true;
  cartRefreshPending = true;
  syncCartChangeControls();
  if (!document.hidden && ($('.cart-drawer').hasClass('show') || document.querySelector('[data-full-cart]'))) fetchCart();
}

function cartMutationRequest(settings) {
  var url;
  try { url = new URL(settings.url, window.location.href); } catch (ignore) { return false; }
  if (url.origin === window.location.origin &&
      /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname) &&
      !/^(GET|HEAD)$/i.test(settings.type || 'GET')) return true;
  return url.origin === 'https://minetanbodyskin.com' &&
    url.pathname === '/order-tracking/promocode.php' &&
    /(?:^|&)version=2(?:&|$)/.test(typeof settings.data === 'string' ? settings.data : url.search.slice(1));
}

// Register settlement before app callbacks, so a throwing integration cannot
// leave the basket locked. Preserve the original XMLHttpRequest implementation.
$.ajaxPrefilter(function(settings, original, xhr) {
  if (!cartMutationRequest(settings)) return;
  cartWriteCount++;
  if (!settings.minetanQueuedCartChange) {
    cartExternalWrites++;
    cartChangeRevision++;
    cartRefreshRequired = true;
  }
  syncCartChangeControls();
  xhr.always(function() {
    cartWriteCount = Math.max(0, cartWriteCount - 1);
    if (!settings.minetanQueuedCartChange) cartExternalWrites = Math.max(0, cartExternalWrites - 1);
    if (xhr.status >= 200 && xhr.status < 300) {
      try { localStorage.setItem(cartSyncStorageKey, Date.now() + ':' + Math.random()); } catch (ignore) {}
    }
    syncCartChangeControls();
    // Let the existing response handlers apply their cart state or enqueue edits.
    setTimeout(function() {
      if (!cartWriteCount && (cartRefreshRequired || cartRefreshPending)) fetchCart();
    }, 0);
  });
});
window.addEventListener('storage', function(event) {
  if (event.key === cartSyncStorageKey && event.newValue) requestCartReconciliation();
});
window.addEventListener('focus', requestCartReconciliation);
window.addEventListener('pageshow', function(event) {
  if (event.persisted) requestCartReconciliation();
});
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) requestCartReconciliation();
});

function syncCartChangeControls() {
  var pendingKeys = cartChangeQueue.map(function(change) { return change.key; });
  if (cartChangeInFlight) pendingKeys.push(cartChangeInFlight.key);
  $('#cartDrawerItems .cart-item').each(function() {
    var pending = cartNeedsReconciliation() || pendingKeys.indexOf($(this).attr('data-item-key')) !== -1;
    var $item = $(this).attr('aria-busy', pending ? 'true' : 'false');
    $item.find('[data-cart-action]').attr('data-cart-pending', pending ? 'true' : 'false');
    $item.find('[data-cart-action="remove"]').attr('aria-disabled', pending ? 'true' : 'false');
    updateCartQuantityControls($item);
  });
  $('.cart-drawer .checkout-button').prop('disabled', cartNeedsReconciliation() || pendingKeys.length > 0);
  if (window.minetanFullCart) window.minetanFullCart.setPending(cartNeedsReconciliation() || cartWriteCount > 0 || pendingKeys.length > 0);
}

function showCartChangeError(xhr) {
  var $error = $('.cart-change-error');
  var message = $error.attr('data-change-error') || 'We could not update your cart. Please try again.';
  var response = xhr && xhr.responseJSON;
  if (!response && xhr && xhr.responseText) {
    try { response = JSON.parse(xhr.responseText); } catch (ignore) {}
  }
  if (response && typeof response.description === 'string' && response.description.trim()) message = response.description;
  else if (response && typeof response.message === 'string' && response.message.trim()) message = response.message;
  $error.text(message).show();
  var visibleError = $error.filter(':visible')[0];
  if (visibleError && $('.cart-drawer').hasClass('show')) visibleError.focus();
  if (window.minetanFullCart) window.minetanFullCart.showError(message, cartReadFailed);
}

function finishCartChange() {
  cartChangeInFlight = null;
  syncCartChangeControls();
  processCartChangeQueue();
  if (!cartChangeInFlight && cartRefreshPending) {
    cartRefreshPending = false;
    fetchCart();
  }
}

function processCartChangeQueue() {
  if (cartChangeInFlight || !cartChangeQueue.length) return;
  var change = cartChangeQueue.shift();
  cartChangeInFlight = change;
  cartChangeRevision++;
  syncCartChangeControls();
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    minetanQueuedCartChange: true,
    data: { id: change.key, quantity: change.quantity },
    dataType: 'json',
    success: function(cart) {
      validateGiftsInCart(cart, function(updatedCart) {
        var currentCart = updatedCart || cart;
        applyCartState(currentCart);
        finishCartChange();
        if (typeof change.callback === 'function') change.callback(currentCart);
      });
    },
    error: function(xhr) {
      // Do not apply queued intentions against a cart that rejected the preceding edit.
      cartChangeQueue = [];
      if (cartCurrentState) applyCartState(cartCurrentState);
      showCartChangeError(xhr);
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: applyCartState,
        complete: function() {
          finishCartChange();
          $('.cart-drawer').removeClass('loading');
          showCartChangeError(xhr);
        }
      });
    }
  });
}

function changeItem(itemKey, quantity, callback) {
  if (cartNeedsReconciliation()) return;
  if (typeof itemKey !== 'string' || !itemKey || !Number.isSafeInteger(quantity) || quantity < 0) return;
  if ((cartChangeInFlight && cartChangeInFlight.key === itemKey) || cartChangeQueue.some(function(change) { return change.key === itemKey; })) return;
  $('.cart-change-error').empty().hide();
  cartChangeQueue.push({ key: itemKey, quantity: quantity, callback: callback });
  syncCartChangeControls();
  processCartChangeQueue();
}

// Helper function to check if value matches comma-separated list
function matchesGiftValue(ruleValue, productValue) {
    if (!ruleValue || !productValue) return false;
    var values = ruleValue.split(',').map(function(v) { return v.trim(); });
    return values.indexOf(productValue) !== -1;
}

// Validate gifts in cart and remove those that no longer qualify
function validateGiftsInCart(cart, callback) {
    var giftRules = window.marq_gifts_config || [];
    if (!giftRules.length) {
        if (callback) callback(cart);
        return;
    }
    
    var giftsToRemove = [];
    var giftsToAdjust = [];
    
    // Find all gift items in cart
    cart.items.forEach(function(item, index) {
        if (item.properties && item.properties._gift === 'true') {
            var giftHandle = item.handle;
            var giftQty = item.quantity;
            
            // Find the matching rule for this gift
            var matchingRule = null;
            giftRules.forEach(function(rule) {
                if (rule.active && rule.handle === giftHandle) {
                    matchingRule = rule;
                }
            });
            
            if (!matchingRule) {
                // No active rule for this gift, remove it
                giftsToRemove.push(item.key);
                return;
            }
            
            // Count qualifying products in cart (excluding gifts)
            var qualifyingQty = 0;
            cart.items.forEach(function(cartItem) {
                // Skip gift items
                if (cartItem.properties && cartItem.properties._gift === 'true') return;
                
                var itemMatches = false;
                if (matchingRule.with_product_handle && matchesGiftValue(matchingRule.with_product_handle, cartItem.handle)) {
                    itemMatches = true;
                } else if (matchingRule.product_type && matchesGiftValue(matchingRule.product_type, cartItem.product_type)) {
                    itemMatches = true;
                } else if (matchingRule.product_vendor && matchesGiftValue(matchingRule.product_vendor, cartItem.vendor)) {
                    itemMatches = true;
                }
                
                if (itemMatches) {
                    qualifyingQty += cartItem.quantity;
                }
            });
            
            if (qualifyingQty === 0) {
                // No qualifying products, remove the gift
                giftsToRemove.push(item.key);
            } else if (!matchingRule.once && matchingRule.max_gifts) {
                // Check if gift quantity needs adjustment
                var maxAllowed = Math.min(qualifyingQty, matchingRule.max_gifts);
                if (giftQty > maxAllowed) {
                    giftsToAdjust.push({ key: item.key, newQty: maxAllowed });
                }
            }
        }
    });
    
    // Process removals and adjustments sequentially
    function processNext() {
        if (giftsToRemove.length > 0) {
            var itemKey = giftsToRemove.pop();
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: { id: itemKey, quantity: 0 },
                dataType: 'json',
                success: function(updatedCart) {
                    // Validate the latest state before processing another queued edit
                    validateGiftsInCart(updatedCart, callback);
                },
                error: function() {
                    if (callback) callback(cart);
                }
            });
        } else if (giftsToAdjust.length > 0) {
            var adjustment = giftsToAdjust.pop();
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: { id: adjustment.key, quantity: adjustment.newQty },
                dataType: 'json',
                success: function(updatedCart) {
                    validateGiftsInCart(updatedCart, callback);
                },
                error: function() {
                    if (callback) callback(cart);
                }
            });
        } else {
            if (callback) callback(cart);
        }
    }
    
    processNext();
}

function applyCartState(cart) {
  cartCurrentState = cart;
  cart_id = cart.token;
  if (cart.item_count === 0) {
    var focusWasInItems = $(document.activeElement).closest('#cartDrawerItems').length > 0;
    $('#cartDrawerItems').empty();
    $('#cart-full-state').hide();
    $('#cart-empty-state').show();
    if (focusWasInItems) $('#cart-empty-state p').attr('tabindex', '-1').focus();
  } else {
    renderCart(cart);
    $('#cart-full-state').show();
    $('#cart-empty-state').hide();
  }
  if (window.minetanFullCart) window.minetanFullCart.applyState(cart);
  $('.cartcount').text(cart.item_count);
  $('.cart-drawer').removeClass('loading');
  syncCartChangeControls();
}

function fetchCart() {
  cartRefreshRequired = true;
  if (cartReadInFlight) {
    if (cartReadRevision !== cartChangeRevision) cartRefreshPending = true;
    syncCartChangeControls();
    return;
  }
  if (cartChangeInFlight || cartWriteCount) {
    cartRefreshPending = true;
    syncCartChangeControls();
    return;
  }
  cartRefreshPending = false;
  cartReadInFlight = true;
  var revision = cartReadRevision = cartChangeRevision;
  $('.cart-drawer').addClass('loading');
  syncCartChangeControls();
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    timeout: 15000,
    success: function(cart) {
      // Ignore reads invalidated by another tab, a write, or a newer refresh.
      if (revision !== cartChangeRevision || cartChangeInFlight || cartWriteCount) {
        cartRefreshPending = true;
        return;
      }
      cartRefreshRequired = false;
      if (cartReadFailed) $('.cart-change-error').empty().hide();
      cartReadFailed = false;
      applyCartState(cart);
    },
    error: function(xhr) {
      if (revision === cartChangeRevision && !cartChangeInFlight) {
        cartReadFailed = true;
        showCartChangeError(xhr);
      }
    },
    complete: function() {
      cartReadInFlight = false;
      $('.cart-drawer').removeClass('loading');
      syncCartChangeControls();
      if (cartRefreshPending && !cartChangeInFlight && !cartWriteCount) fetchCart();
    }
  });
}

function updateFreeShipping(total, items_types) {
  var $block = $('#fs-cart-block');
  if($block.length === 0) return;
  var goal = parseInt($block.attr('data-goal'))*100;
  var exclude_types = $block.attr('data-exclude-product-types').split(','); 
  if(exclude_types.length > 0) {
  	for(var i in items_types) {
      if(exclude_types.indexOf(items_types[i]) !== -1) {
        $('.free-shipping-progress').hide();
        $('.free-shipping-success').hide();        
        return;
      }
  	}
  } 
  
  if(total>=goal) {
  	$('.free-shipping-progress').hide();
    $('.free-shipping-success').show();
  } else {
  	$('.free-shipping-progress').show();
    $('.free-shipping-success').hide();
  	$('.fs-amount').text(Shopify.formatMoney(goal-total, money_format_type));
    var progress = (total/goal) *100;
    $('#fs-bar > div').css('width', progress+'%')
  }
}

// Kit properties come from the cart request, so treat them as untrusted text.
function escapeCartKitText(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function cartKitImageUrl(value) {
  if (typeof value !== 'string') return '';
  var url = value.trim();
  // Allow web URLs, protocol-relative CDN URLs, and paths from the site root.
  return /^(https?:\/\/|\/)/i.test(url) ? url : '';
}

function renderCart(cart) {
  cartCurrentState = cart;
  // Replacing the cart markup should not strand keyboard focus on the body.
  var $focusedControl = $(document.activeElement);
  var focusedAction = $focusedControl.attr('data-cart-action');
  var $focusedItem = $focusedControl.closest('#cartDrawerItems .cart-item');
  var focusedKey = $focusedItem.attr('data-item-key');
  var focusedLine = parseInt($focusedItem.attr('data-line'), 10);
  var html = '';
  var types = [];
  var vendors = [];
  var variant_ids = [];
  var $upsale_blocks = $('.add-me-to-save'); 
  var upsale_shown = false;
  var check_qty_data = [];
  
  cart.items.forEach(function(item, index) { 
      const productImage = '<figure><a href="'+item.url+'"><img class="image" src="' + item.image + '" ></a></figure>';    
      const productTitle = '<a href="'+item.url+'" class="title">' + item.title + '</a>';
      let kitHtml = '';
      if(item.properties && Object.keys(item.properties).length > 0) {
        let isKit = item.product_type === 'Mine Kit' || item.product_type === 'Mine Value Pack' || item.product_type === 'Mine Bronze Babe' || (typeof item.properties._mists_required !== 'undefined');
        if(isKit) {
          let subItems = [];
          for (const property in item.properties) {
            if ((property.startsWith('_selected_main_title_') || property.startsWith('_selected_mist_title_'))
               && item.properties[property] !== '') {
              let img = item.properties[property.replace('title', 'img')];
              subItems.push({ title: item.properties[property], img: img });
            }
          }
          if(subItems.length > 0) {
            kitHtml = '<div class="kit-items">';
            subItems.forEach(function(subItem) {
              var imageUrl = cartKitImageUrl(subItem.img);
              var imageHtml = imageUrl ? '<img src="' + escapeCartKitText(imageUrl) + '" />' : '';
              kitHtml += '<div class="kit-item"><div class="img-hold">' + imageHtml + '</div><div class="kit-title">' + escapeCartKitText(subItem.title) + '</div></div>';
            });
            kitHtml += '</div>';
          }
        }
      }
      var linePrice = item.final_line_price < item.original_line_price ? item.final_line_price : item.line_price;
      if(linePrice < item.original_line_price) {
        var productPrice = '<div class="price"><div>' +  Shopify.formatMoney(linePrice, money_format_type) + '</div><div class="old-price">' +  Shopify.formatMoney(item.original_line_price, money_format_type) + '</div></div>';
      } else {
        var productPrice = '<div class="price">' +  Shopify.formatMoney(linePrice, money_format_type) + '</div>';
      }
      var block_qty = (item.vendor == 'Private Label' ? ' block' : '');
      const productQuantity = '<div class="quantity--contain">'+
            '<label for="quantity">'+texts.qty+' </label>'+
            '<button type="button" data-cart-action="decrease" aria-label="'+escapeCartKitText(texts.decrease + ': ' + item.title)+'" aria-disabled="'+(block_qty !== '')+'" class="dec button'+block_qty+'">-</button>'+
            '<input type="text" id="quantity" readonly name="updates[]" aria-label="'+escapeCartKitText(texts.qty + ' ' + item.title)+'" data-value="1" data-min="1" value="' + item.quantity + '">'+
			'<button type="button" data-cart-action="increase" aria-label="'+escapeCartKitText(texts.increase + ': ' + item.title)+'" aria-disabled="'+(block_qty !== '')+'" class="inc button'+block_qty+'">+</button>' +
			'</div>'; 
      const productRemove = '<div class="remove-hold"><button type="button" data-cart-action="remove" aria-label="'+escapeCartKitText(texts.remove + ': ' + item.title)+'" class="remove"></button></div>';

      const concatProductInfo = '<div class="cart-item" data-line="' + Number(index + 1) + '" data-item-key="'+escapeCartKitText(item.key)+'" data-product-id="'+item.product_id+'">' + productImage
      + '<div class="title-column">'+productTitle+ kitHtml +'<div class="quant-row">'+ productQuantity +productRemove+productPrice  + '</div></div>' +
      '</div>';
      types.push( item.product_type );
      vendors.push( item.vendor); 
      variant_ids.push( item.variant_id );
      if(item.vendor == 'Private Label') {
        check_qty_data.push(item.product_id);
      }
      html = html + concatProductInfo; 
  });
  
  if( $upsale_blocks.length>0) {
    $upsale_blocks.each(function() {
      var variant_id = parseInt($(this).attr('data-variant-id'));
      var product_type =  $(this).attr('data-product-type').split(',');
      var vendor =  $(this).attr('data-vendor');
      var common_types = product_type.filter(x => types.indexOf(x) !== -1);
      if(variant_ids.indexOf(variant_id) === -1 && !upsale_shown &&
         ( (vendor !== '' && vendors.indexOf(vendor) !== -1) || (product_type.length>0 && common_types.length>0) ) ) {
        $(this).show();
        upsale_shown = true;
      } else {
        $(this).hide();
      }
    });
  }
  $('#cartDrawerItems').html(html);
  $('#cartDrawerItems .cart-item').each(function() {
    updateCartQuantityControls($(this));
  });
  if ($focusedItem.length && focusedAction) {
    var focusedIndex = cart.items.findIndex(function(item) { return item.key === focusedKey; });
    if (focusedIndex === -1) focusedIndex = Math.min(focusedLine - 1, cart.items.length - 1);
    var $replacement = $('#cartDrawerItems .cart-item').eq(focusedIndex).find('[data-cart-action="'+focusedAction+'"]');
    if ($replacement.length) $replacement[0].focus({ preventScroll: true });
  }
  if(check_qty_data.length>0) {
    for(var i in check_qty_data) {
      getQtyData(check_qty_data[i]);
    }
  }
  
  var total = cart.total_price;
  $('.cart-content').removeClass('with-discount');
  
  $('#cartDrawerSubtotal').html( Shopify.formatMoney(cart.original_total_price, money_format_type) );
  $('#cartDrawerTotal').html( Shopify.formatMoney(total, money_format_type) );
  
  updateFreeShipping(cart.items_subtotal_price, types, vendors);
  fetchDiscount(cart);
  
  $('.cart-drawer').removeClass('loading');
  syncCartChangeControls();
}

function staticCartInitFreeShipping() {
  if($('.free-shipping.static-cart').length === 0) return;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) { 
          if (cart.item_count != 0) {  
            var types = [];
            var vendors = [];
            cart.items.forEach(function(item, index) {  
                types.push( item.product_type );
                vendors.push( item.vendor); 
            });
            updateFreeShipping(cart.items_subtotal_price, types, vendors);
          } 
      },
  });
}

function positiveCartQuantity(value, fallback) {
  if (typeof value !== 'number' && typeof value !== 'string') return fallback;
  var quantity = Number(value);
  return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : fallback;
}

function updateCartQuantityControls($item) {
  var $input = $item.find('input[name="updates[]"]');
  var minimum = positiveCartQuantity($input.attr('data-min'), 1);
  var quantity = positiveCartQuantity($input.val(), minimum);
  var $decrease = $item.find('[data-cart-action="decrease"]');
  var $increase = $item.find('[data-cart-action="increase"]');
  var pending = $item.attr('aria-busy') === 'true';
  $decrease.attr('aria-disabled', pending || $decrease.hasClass('block') || quantity <= minimum ? 'true' : 'false');
  $increase.attr('aria-disabled', pending || $increase.hasClass('block') ? 'true' : 'false');
}

function getQtyData(product_id) {
  $.ajax({
      type: 'GET', 
      url: 'https://minetanbodyskin.com/order-tracking/metafields-min-qty.php',
      data: 'store='+store+'&id=' + product_id,
      dataType: 'json',
      success: function(response) {
        if (!response || !response.success || !response.data) return;
        var step = positiveCartQuantity(response.data.step, null);
        var minimum = positiveCartQuantity(response.data.min, null);
        if (step === null || minimum === null) return;

        $('#cartDrawerItems .cart-item[data-product-id="'+product_id+'"]').each(function() {
          var $item = $(this);
          $item.find('input[name="updates[]"]').attr('data-value', step).attr('data-min', minimum);
          $item.find('.button.block').removeClass('block');
          updateCartQuantityControls($item);
        });
      }
  });
}

function initCartQuantityControls() {
 $(document).off("click.cartQuantity", "#cartDrawerItems .quantity--contain .button").on("click.cartQuantity", "#cartDrawerItems .quantity--contain .button", function(e) {
    e.preventDefault();
    if (this.disabled || $(this).attr('aria-disabled') === 'true') return;
    var $item = $(this).closest('.cart-item');
    var $input = $item.find('input[name="updates[]"]');
    var step = positiveCartQuantity($input.attr('data-value'), 1);
    var minimum = positiveCartQuantity($input.attr('data-min'), 1);
    var oldValue = positiveCartQuantity($input.val(), minimum);
    var increase = $(this).attr('data-cart-action') === 'increase';
    var newVal = Math.max(minimum, oldValue + (increase ? step : -step));

    $input.val(newVal);
    updateCartQuantityControls($item);
    if (newVal === oldValue) return;

    var itemKey = $item.attr('data-item-key');
    changeItem(itemKey, newVal);
  });

} 

function initDiscountField() {
  $('[id="cart-discount-field"]').off('.cartDiscount').on('input.cartDiscount', function() {
    clearCartPromoError();
  }).on('keydown.cartDiscount', function(e) {
    if (e.key === 'Enter' || e.which === 13) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.originalEvent || !e.originalEvent.repeat) {
        $(this).closest('.cart-promocode-form').find('[id="cart-apply-discount"]').trigger('click');
      }
    }
  });
  $('[id="cart-apply-discount"]').off('.cartDiscount').on('click.cartDiscount', function(e) {
    e.preventDefault();
    var $field = $(this).closest('.cart-promocode-form').find('[id="cart-discount-field"]');
    if (!$field.prop('readonly')) {
      applyDiscount($field.val());
    } else {
      removeDiscount();
    }
  });
}

function fetchDiscount(cart) {
  var codes = [];
  function collectCode(application) {
    if (application && application.type === 'discount_code' && application.title && codes.indexOf(application.title) === -1) {
      codes.push(application.title);
    }
  }

  (cart.cart_level_discount_applications || []).forEach(collectCode);
  cart.items.forEach(function(item) {
    (item.line_level_discount_allocations || []).forEach(function(allocation) {
      collectCode(allocation.discount_application);
    });
  });

  var hasCode = codes.length > 0;
  $('[id="cart-discount-field"]').val(codes.join(',')).prop('readonly', hasCode);
  $('[id="cart-apply-discount"]').text(hasCode ? texts.remove : texts.apply);

  // Automatic discounts affect savings even when there is no removable promo code.
  var hasSavings = cart.total_discount > 0;
  $('.cart-content').toggleClass('with-discount', hasSavings);
  $('#cartDrawerDiscount').html(hasSavings ? '-' + Shopify.formatMoney(cart.total_discount, money_format_type) : '');
}

var cartPromoPending = false;

function clearCartPromoError() {
  $('.cart-promocode-error, #cart-promocode-error').remove();
  $('[id="cart-discount-field"]').removeAttr('aria-invalid aria-describedby');
}

function showCartPromoError(message) {
  clearCartPromoError();
  $('.cart-promocode-form').each(function(index) {
    var $form = $(this);
    var text = typeof message === 'string' && message.trim() ? message :
      ($form.attr('data-promo-error') || 'We could not update your promo code. Please try again.');
    var id = 'CartPromoError-' + index;
    $('<p>').addClass('error cart-promocode-error').attr({ id: id, role: 'alert' }).text(text).appendTo($form);
    $form.find('[id="cart-discount-field"]').attr({ 'aria-invalid': 'true', 'aria-describedby': id });
  });
}

function updateCartPromoCode(code, removing) {
  if (cartPromoPending) return;
  cartPromoPending = true;
  clearCartPromoError();
  var $fields = $('[id="cart-discount-field"]');
  var $buttons = $('[id="cart-apply-discount"]');
  var previousReadonly = $fields.map(function() { return this.readOnly; }).get();
  var applied = false;
  $fields.prop('readonly', true);
  $buttons.prop('disabled', true);
  $('.cart-promocode-form').attr('aria-busy', 'true');
  $.ajax({
    type: 'GET',
    url: 'https://minetanbodyskin.com/order-tracking/promocode.php',
    data: { store: store, promocode: code, version: 2, cart_id: cart_id },
    dataType: 'json',
    timeout: 15000,
    success: function(response) {
      if (!response || typeof response !== 'object' || Array.isArray(response)) {
        showCartPromoError();
        return;
      }
      if (typeof response.success !== 'undefined' && !response.success) {
        showCartPromoError(response.error);
        return;
      }
      applied = true;
      $fields.val(removing ? '' : code).prop('readonly', !removing);
      $buttons.text(removing ? texts.apply : texts.remove);
      clearCartPromoError();
      if ($('.free-shipping.static-cart').length === 0) fetchCart();
      else window.location.reload();
    },
    error: function(xhr) {
      showCartPromoError(xhr.responseJSON && xhr.responseJSON.error);
    },
    complete: function() {
      cartPromoPending = false;
      $buttons.prop('disabled', false);
      $('.cart-promocode-form').attr('aria-busy', 'false');
      if (!applied) $fields.each(function(index) { this.readOnly = previousReadonly[index]; });
    }
  });
}

function applyDiscount(code) {
  updateCartPromoCode(code, false);
}

function removeDiscount() {
  updateCartPromoCode('', true);
}

function setCookie(name,value,minutes) {
  var expires = "";
  if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + (minutes*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function initUpsaleItems() {  
  $('.add-me-to-save').each(function() {
    if( getCookie('dismiss_offer_'+$(this).data('id')) ) {
      $(this).remove();
    }
  });
  $(document).on('click', '.add-me-to-save .title .dismiss', function(e) {
    e.preventDefault();
    var offer = $(this).parent().parent();
    setCookie('dismiss_offer_'+offer.attr('data-id'), true, 20);
    offer.remove();
  });
  
  $(document).on('click', '.add-upsale-item', function(e) {
    e.preventDefault();
    var variant_id = $(this).attr('data-variant-id');
    $.ajax({	
		type: "post",	
        url: "/cart/add.js",	
        data: "quantity=1&id=" + variant_id,	
        dataType: "json" ,
        success: function() {
  			fetchCart();                  
        }
    });
  });
}
 
$(document).ready(function() {
  fetchCart();
  initCartQuantityControls(); 
  initDiscountField();
  initUpsaleItems();
  staticCartInitFreeShipping();
});

$(document).on('click', '.cart-drawer .cart-item .remove', function(e) {
  e.preventDefault();
  if (this.disabled || $(this).attr('aria-disabled') === 'true') return;
  var itemKey = $(this).closest('.cart-item').attr('data-item-key');
  changeItem(itemKey, 0);
});